import React from "react";

import Favorite from '@material-ui/icons/Favorite';

import TranslationService from '../../../services/translation/TransationService';
import Footer from '../../../components/Footer/Footer';
import ListItem from '@material-ui/core/ListItem/ListItem';
import List from '@material-ui/core/List/List';
import {
  locale,
  catalanPublicWebUrl,
  englishPublicWebUrl,
} from './../../../assets/const';

class QxQFooter extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <Footer
        content={
          <div>
            <div className={classes.left}>
              <List className={classes.list}>
                <ListItem className={classes.inlineBlock}>
                  <a
                    href={this.getTermsConditionsDoc()}
                    target="_blank"
                    className={classes.block}
                  >
                    { TranslationService.get('FOOTER.MENU.PRIVACY_POLICY') }
                  </a>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  <a
                    href={this.getTermsConditionsDoc()}
                    target="_blank"
                    className={classes.block}
                  >
                    { TranslationService.get('FOOTER.MENU.TERMS_OF_SERVICE') }
                  </a>
                </ListItem>
                <ListItem className={classes.inlineBlock}>
                  <a
                    href={this.getCookiePolicyDoc()}
                    target="_blank"
                    className={classes.block}
                  >
                    { TranslationService.get('FOOTER.MENU.COOKIE_POLICY') }
                  </a>
                </ListItem>
              </List>
            </div>
            <div className={classes.right}>
              &copy; {1900 + new Date().getYear()} , made with{' '}
              <Favorite className={classes.icon} style={{
                top: 3,
                width: 18,
                height: 18,
                position: "relative",
                fill: "black",
              }}/> by{' '}
              <a href="https://www.lambdaloopers.com" target="_blank" rel="noopener noreferrer">LambdaLoopers</a>.
            </div>
          </div>
        }
      />
    );
  }

  getTermsConditionsDoc() {
    let documentPath = "";
    switch (locale) {
      case "en_GB":
        documentPath = 'documents/legal/eng/terms-conditions.pdf';
        break;
      case "es_CA":
        documentPath = 'documents/legal/cat/terms-conditions.pdf';
        break;
      default:
        documentPath = this.getDefaultDocPath() + '/terms-conditions.pdf';
    }
    return documentPath;
  }

  getCookiePolicyDoc() {
    let documentPath = "";
    switch (locale) {
      case "en_GB":
        documentPath = 'documents/legal/eng/cookies-policy.pdf';
        break;
      case "es_CA":
        documentPath = 'documents/legal/cat/cookies-policy.pdf';
        break;
      default:
        documentPath = this.getDefaultDocPath() + '/cookies-policy.pdf';
    }
    return documentPath;
  }

  getDefaultDocPath() {
    const domain = document.location.origin;
    let path = '';
    switch (domain) {
      case catalanPublicWebUrl:
        path = 'documents/legal/cat';
        break;
      case englishPublicWebUrl:
        path = 'documents/legal/eng';
        break;
      default:
        path = 'documents/legal/esp';
    }
    return path;
  }
}

export default QxQFooter;


// WEBPACK FOOTER //
// ./src/views/QxQPublicPage/Partials/QxQFooter.jsx